/**
 * This is making the assumption that their account is configured with these
 * names because they want custom logic based off of this. So this will break if
 * they change their configuration to not include these names.
 *
 * TODO: Make this less brittle.
 */
export const BC_PROCESS_NAMES = {
  ACCU_ROD: 'AccuRod',
  GRIND_ALL: 'GrindAll',
  NO_CG: 'NoCG',
} as const;
